import React, { useState } from "react";
import "../Style/Navbar.css";
import logo from "../assets/logo.png";
import award1 from "../assets/people.png";
import award2 from "../assets/innovation.png";
import award3 from "../assets/growth.png";
import { FiChevronDown, FiHome, FiX, FiBriefcase } from "react-icons/fi";

const navItems = [
  {
    key: "home",
    label: "Home",
    path: "/",
  },

  {
    key: "services",
    label: "Services",
    items: [
      { label: "UI / UX Design", path: "/uiux-design" },
      { label: "Web Development", path: "/web-development" },
      { label: "App Development", path: "/app-development" },
      { label: "SaaS Development", path: "/saas-development" },
      { label: "Digital Marketing", path: "/digital-marketing" },
      { label: "Graphic Design", path: "/graphic-design" },
      { label: "Video Editing", path: "/video-editing" },
    ],
  },

  // Our Products is now a simple link.
  // It will scroll to the Our Products section on the homepage.
  {
    key: "products",
    label: "Our Products",
    path: "/#our-products",
  },

  {
    key: "resources",
    label: "Resources",
    items: [
      { label: "Case Study", path: "/" },
      { label: "Blog", path: "/blogs-page" },
    ],
  },

  {
    key: "company",
    label: "Company",
    items: [
      { label: "About Us", path: "/about-us" },
      { label: "Clients Projects", path: "/client-projects" },
      { label: "Team", path: "/team-page" },
      { label: "Career", path: "/career-page" },
    ],
  },
];

function Navbar({ onNavigate }) {
  const [openDropdown, setOpenDropdown] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [closing, setClosing] = useState(false);

  // --------------------------------------------------
  // Close Menu Animation
  // --------------------------------------------------

  const handleClose = () => {
    setClosing(true);

    setTimeout(() => {
      setMenuOpen(false);
      setClosing(false);
    }, 350);
  };

  // --------------------------------------------------
  // Navigate to Our Products section
  // --------------------------------------------------

  const scrollToProducts = (retriesLeft = 20) => {
    const el = document.getElementById("our-products");
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    } else if (retriesLeft > 0) {
      // Homepage may not have mounted yet after navigating from
      // another page — keep checking for a short window.
      setTimeout(() => scrollToProducts(retriesLeft - 1), 100);
    }
  };

  const handleProductsNavigation = () => {
    setOpenDropdown(null);

    const goToProducts = () => {
      if (window.location.pathname !== "/") {
        // Navigate to the homepage through the app's own router
        // instead of a hard reload, then wait for the section to
        // mount before scrolling to it.
        onNavigate("/");
      }
      scrollToProducts();
    };

    // If menu is open, close it first
    if (menuOpen) {
      handleClose();
      setTimeout(goToProducts, 350);
    } else {
      goToProducts();
    }
  };

  // --------------------------------------------------
  // Normal Navigation
  // --------------------------------------------------

  const handleNavigate = (path) => {
    setOpenDropdown(null);

    // Our Products
    if (path === "/#our-products") {
      handleProductsNavigation();
      return;
    }

    // If menu is open, close it first
    if (menuOpen) {
      handleClose();

      setTimeout(() => {
        onNavigate(path);
      }, 350);
    } else {
      onNavigate(path);
    }
  };

  // --------------------------------------------------
  // External Links
  // --------------------------------------------------

  const handleExternal = (url) => {
    setOpenDropdown(null);

    window.open(url, "_blank", "noopener,noreferrer");
  };

  // --------------------------------------------------
  // Dropdown Toggle
  // --------------------------------------------------

  const toggleDropdown = (key) => {
    setOpenDropdown((current) =>
      current === key ? null : key
    );
  };

  return (
    <>
      <nav className="navbar-wrap">
        <div className="navbar-pill">

          {/* ----------------------------------------
              BRAND
          ---------------------------------------- */}

          <div
            className="brand-lockup"
            onClick={() => handleNavigate("/")}
          >
            <img
              src={logo}
              alt="MPeoples logo"
              className="logo"
            />

            <span className="brand-name-primary">
              MPeoples
            </span>
          </div>

          {/* ----------------------------------------
              CENTER NAVIGATION
          ---------------------------------------- */}

          <ul className="nav-center">
            {navItems.map((item) => {

              // OUR PRODUCTS
              // Simple link - NO dropdown
              if (item.key === "products") {
                return (
                  <li
                    className="nav-item"
                    key={item.key}
                  >
                    <button
                      type="button"
                      className="nav-link"
                      onClick={handleProductsNavigation}
                    >
                      {item.label}
                    </button>
                  </li>
                );
              }

              // ITEMS WITH DROPDOWNS
              if (item.items) {
                return (
                  <li
                    className="nav-item"
                    key={item.key}
                  >
                    <button
                      type="button"
                      className={`nav-link ${
                        openDropdown === item.key
                          ? "nav-link--active"
                          : ""
                      }`}
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleDropdown(item.key);
                      }}
                    >
                      {item.label}

                      <FiChevronDown
                        className={`nav-chevron ${
                          openDropdown === item.key
                            ? "nav-chevron--open"
                            : ""
                        }`}
                      />
                    </button>

                    {openDropdown === item.key && (
                      <div className="nav-dropdown">
                        <ul>
                          {item.items.map((sub, i) => (
                            <li
                              key={i}
                              onClick={() =>
                                sub.url
                                  ? handleExternal(sub.url)
                                  : handleNavigate(sub.path)
                              }
                            >
                              {sub.label}
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </li>
                );
              }

              // NORMAL LINKS
              return (
                <li
                  className="nav-item"
                  key={item.key}
                >
                  <button
                    type="button"
                    className="nav-link"
                    onClick={() =>
                      handleNavigate(item.path)
                    }
                  >
                    {item.label}
                  </button>
                </li>
              );
            })}
          </ul>

          {/* ----------------------------------------
              RIGHT ACTIONS
          ---------------------------------------- */}

          <div className="nav-actions">

            {/* Client Projects */}
            <button
              type="button"
              className="nav-project-icon-btn"
              onClick={() =>
                handleNavigate("/client-projects")
              }
              aria-label="View Client Projects"
              title="Client Projects"
            >
              <FiBriefcase />
            </button>

            {/* Menu */}
            <button
              type="button"
              className={`menu-trigger ${
                menuOpen
                  ? "menu-trigger--active"
                  : ""
              }`}
              onClick={() =>
                menuOpen
                  ? handleClose()
                  : setMenuOpen(true)
              }
            >
              <span className="menu-trigger-icon">
                <span></span>
                <span></span>
                <span></span>
              </span>

              <span className="menu-trigger-text">
                {menuOpen ? "Close" : "Menu"}
              </span>
            </button>

          </div>
        </div>

        {/* ----------------------------------------
            CLICK OUTSIDE DROPDOWN
        ---------------------------------------- */}

        {openDropdown && (
          <div
            className="nav-dropdown-catcher"
            onClick={() =>
              setOpenDropdown(null)
            }
          />
        )}
      </nav>

      {/* ------------------------------------------
          MENU PANEL
      ------------------------------------------ */}

      {menuOpen && (
        <>
          {/* Backdrop */}
          <div
            className={`menu-backdrop ${
              closing
                ? "menu-backdrop--closing"
                : ""
            }`}
            onClick={handleClose}
          />

          {/* Menu Panel */}
          <div
            className={`menu-panel ${
              closing
                ? "menu-panel--closing"
                : ""
            }`}
          >

            {/* --------------------------------------
                PANEL HEADER
            -------------------------------------- */}

            <div className="panel-header">

              {/* Home */}
              <button
                type="button"
                className="panel-home-btn"
                onClick={() =>
                  handleNavigate("/")
                }
                aria-label="Go to Home"
              >
                <FiHome />
                <span>Home</span>
              </button>

              {/* Close */}
              <button
                type="button"
                className="panel-close-btn"
                onClick={handleClose}
                aria-label="Close menu"
              >
                <FiX />
              </button>

            </div>

            {/* --------------------------------------
                PANEL LINKS
            -------------------------------------- */}

            <div className="panel-links">

              {/* ====================================
                  COLUMN 1
              ==================================== */}

              <div className="link-column">

                {/* Services */}
                <h3 className="col-title">
                  Services
                </h3>

                <ul>
                  {navItems[1].items.map(
                    (sub, i) => (
                      <li
                        key={i}
                        onClick={() =>
                          handleNavigate(
                            sub.path
                          )
                        }
                      >
                        {sub.label}
                      </li>
                    )
                  )}
                </ul>

                {/* Our Products */}
                <h3 className="col-title second-title">
                  Our Products
                </h3>

                <ul>
                  <li
                    onClick={
                      handleProductsNavigation
                    }
                  >
                    View Our Products
                  </li>
                </ul>

              </div>

              {/* ====================================
                  COLUMN 2
              ==================================== */}

              <div className="link-column">

                {/* Resources */}
                <h3 className="col-title">
                  Resources
                </h3>

                <ul>
                  {navItems[3].items.map(
                    (sub, i) => (
                      <li
                        key={i}
                        onClick={() =>
                          handleNavigate(
                            sub.path
                          )
                        }
                      >
                        {sub.label}
                      </li>
                    )
                  )}
                </ul>

                {/* Company */}
                <h3 className="col-title second-title">
                  Company
                </h3>

                <ul>
                  {navItems[4].items.map(
                    (sub, i) => (
                      <li
                        key={i}
                        onClick={() =>
                          handleNavigate(
                            sub.path
                          )
                        }
                      >
                        {sub.label}
                      </li>
                    )
                  )}
                </ul>

                {/* Terms */}
                <h3 className="col-title second-title">
                  Terms & Policies
                </h3>

                <ul>
                  <li
                    onClick={() =>
                      handleNavigate(
                        "/termsandconditions/"
                      )
                    }
                  >
                    Terms of Service
                  </li>

                  <li
                    onClick={() =>
                      handleNavigate(
                        "/privacypolicy/"
                      )
                    }
                  >
                    Privacy Policy
                  </li>

                  <li
                    onClick={() =>
                      handleNavigate(
                        "/paymentpolicy/"
                      )
                    }
                  >
                    Payment Policy
                  </li>
                </ul>

              </div>

            </div>

            {/* --------------------------------------
                AWARDS
            -------------------------------------- */}

            <div className="panel-footer">

              <img
                src={award1}
                alt="award"
                className="award-img"
              />

              <img
                src={award2}
                alt="award"
                className="award-img"
              />

              <img
                src={award3}
                alt="award"
                className="award-img"
              />

            </div>

          </div>
        </>
      )}
    </>
  );
}

export default Navbar;